import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";
import {
  readCookie,
  getPortalCD,
  getFallbackIPAddress,
} from "../../utils/helpers";
import FunnelStepTypes from "../funnel-step/types";
import { EMPTY_GUID } from "../../utils/constants";
import { getI18n } from "react-i18next";

const quack = () => ({
  type: Types.QUACK,
});
const loginUserAndAuthenticate = (data) => {
  return async function (dispatch) {
    let ipAddress = data?.ipAddress;
    if (!ipAddress) {
      ipAddress = await getFallbackIPAddress();
    }

    const loginAttemptReq = {
      emailAddress: data.Username.trim(),
      ipAddress: ipAddress,
      attemptType: "Login",
      visitorId: readCookie("visitorGuid"),
      visitId: readCookie("visitGuid"),
      createdBy: readCookie("visitorGuid"),
      portalCD: getPortalCD(),
      greCaptchaToken: "",
      isCaptchaRequired: true,
    };

    return AssessmentServiceApi.loginAttempt(loginAttemptReq)
      .then((loginResponse) => {
        if (
          loginResponse &&
          loginResponse.id !== EMPTY_GUID &&
          loginResponse.error === ""
        ) {
          if (loginResponse?.tempIPAddress) {
            dispatch(
              PushUserInformationToFunnelStep({
                ipAddress: loginResponse?.tempIPAddress,
              }),
            );
          }
          return AssessmentServiceApi.loginUser(data?.Username).then(
            (response) => {
              if (!!response) {
                const fullName =
                  response.firstName?.trim() || response.lastName?.trim()
                    ? `${response.firstName ?? ""} ${response.lastName ?? ""}`.trim()
                    : (response?.userName ?? "");

                // createCookie("userguid", response?.userGuid, 1);
                // createCookie("uname", fullName, 1);
                // createCookie("accnum", response?.accountNumber, 1);

                dispatch(
                  PushUserInformationToFunnelStep({
                    userGUID: response?.userGuid,
                    uname: fullName,
                    accnum: response?.accountNumber,
                    email: data.Username,
                  }),
                );

                if (response?.countryCD && response?.currencyCD) {
                  dispatch(
                    PushUserInformationToFunnelStep({
                      countryCD: response?.countryCD,
                      currencyCD: response?.currencyCD,
                    }),
                  );
                }

                const authData = {
                  Username: data.Username,
                  email: data.Username,
                  password: data.Password,
                  userGuid: response?.userGuid,
                  isSocialLogin: false,
                };
                return AssessmentServiceApi.AuthenticateExternalUser(
                  authData,
                ).then((authResponse) => {
                  const { isAuth } = authResponse;
                  // localStorage.setItem("jwtToken", jwtToken);
                  // localStorage.setItem("refreshToken", refreshToken);
                  // localStorage.setItem("expiresAt", expiresAt);
                  // createCookie("jwtToken", jwtToken, 1);
                  // createCookie("refreshToken", refreshToken, 1);
                  // createCookie("expiresAt", expiresAt, 1);
                  if (isAuth) {
                    dispatch(
                      PushUserInformationToFunnelStep({
                        isAuth: isAuth,
                      }),
                    );

                    return response;
                  }
                });
              } else {
                return response;
              }
            },
          );
        } else if (
          loginResponse?.statusCode === 426 &&
          loginResponse?.error === "maximum_login_attempt"
        ) {
          throw new Error(getI18n().t("login.maximum_login_attempt"));
        } else {
          throw new Error(loginResponse?.error);
        }
      })
      .catch((error) => {
        console.log("Error", error);
        throw error;
      });
  };
};

const updateUserId = (data) => {
  return function (dispatch) {
    return AssessmentServiceApi.updateUserId(data)
      .then((response) => {
        return response;
      })
      .catch((error) => console.log("Error", error));
  };
};

const decryptURL = (token) => {
  return function () {
    return AssessmentServiceApi.decryptURL(token)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Guest User Error", error));
  };
};
const PushUserInformationToFunnelStep = (userInformation) => ({
  type: FunnelStepTypes.SET_USERINFO,
  payload: userInformation,
});
export { quack, loginUserAndAuthenticate, updateUserId, decryptURL };
